/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Dialog, FilledButton, OutlinedButton } from '@neo4j-ndl/react';
import { useRef, useState } from 'react';

const Component = (props: { isOpen: boolean }) => {
  const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);
  const handleClick = () => setIsOpen((prev) => !prev);
  const handleClose = () => setIsOpen(false);

  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <div
      ref={ref}
      className="n-flex n-flex-col n-items-center n-justify-center n-relative n-h-[500px] n-w-full"
    >
      <div className="n-flex n-justify-center">
        <FilledButton
          onClick={handleClick}
          htmlAttributes={{ 'aria-haspopup': 'dialog' }}
        >
          Open Dialog
        </FilledButton>
      </div>
      <Dialog
        onClose={handleClose}
        isOpen={isOpen}
        container={ref?.current || undefined}
        htmlAttributes={{ id: 'default-dialog' }}
      >
        <Dialog.Header>Header</Dialog.Header>
        <Dialog.Description>This is a description</Dialog.Description>
        <Dialog.Content>This is where you put your content</Dialog.Content>
        <Dialog.Actions>
          <OutlinedButton onClick={handleClose} variant="neutral" size="medium">
            Secondary
          </OutlinedButton>
          <FilledButton onClick={handleClose} size="medium">
            Primary
          </FilledButton>
        </Dialog.Actions>
      </Dialog>
    </div>
  );
};

export default Component;
